import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';

const LinearProgressWithLabel = props => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <Box
      sx={{
        width: '100%',
        mr: 1,
      }}
    >
      <LinearProgress variant="determinate" {...props} />
    </Box>
    <Box
      sx={{
        minWidth: 35,
      }}
    >
      <Typography variant="body2" color="textSecondary">
        {`${Math.round(props.value)}%`}
      </Typography>
    </Box>
  </Box>
);

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

export default LinearProgressWithLabel;
